<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="solicitacaoHonra; else carregando">

    <div class="row">
        <div class="col">
            <h3>Detalhes da Solicitação de Honra</h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltarParaLista ()">Voltar</button>
            <button *ngIf="podeReprovar" [disabled] = "solicitacaoHonra.estado.id != 2"
                class="btn btn-light" type="button" (click)="reprovar()">Reprovar </button>
        </div>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">
        <li [ngbNavItem]>
        <a ngbNavLink>Solicitação</a>
        <ng-template ngbNavContent>
        <div class="row" >
            <div class="bn-form-group col-md-8">
                <label><b>Agente financeiro</b></label>
                <input type="text" class="form-control" name="nomeAgenteFinanceiro" value="{{nomeAgente(solicitacaoHonra.cnpjAgenteFinanceiro)}}" disabled />
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Janela</b></label>
                <input type="text" class="form-control" name="nomeJanela" value="{{solicitacaoHonra.nomeJanela}}" disabled />
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Id. sol. honra</b></label>
                <input type="text" class="form-control" name="idSolicitacaoHonra" value="{{solicitacaoHonra.id}}" disabled />
            </div>
        </div>
        <div class="row">
            <div class="bn-form-group col-md-6">
                <label><b>Origem Protocolo</b></label>
                <input type="text" class="form-control" name="descricaoOrigemProtocolo" value="{{solicitacaoHonra.descricaoOrigemProtocolo}}"  disabled />
            </div>
            <div class="bn-form-group col-md-6" *ngIf="solicitacaoHonra.idOperacaoExterno">
                <label><b>Id. operação agente</b></label>
                <input type="text" class="form-control" name="idOperacaoAgente" value="{{solicitacaoHonra.idOperacaoExterno}}"  disabled />
            </div>
            <div class="bn-form-group col-md-2" *ngIf="solicitacaoHonra.sistemaRepasse">
                <label><b>Sist. cobrança</b></label>
                <input type="text" class="form-control" value="{{solicitacaoHonra.sistemaRepasse}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.contratoRepasse">
                <label><b>Contrato</b></label>
                <div class="input-group">
                    <input type="text" class="form-control" [value]="solicitacaoHonra.contratoRepasse" disabled />
                    <div *ngIf="permissaoLinkN03 && solicitacaoHonra.contratoRepasse">
                        <span class="input-group-text"><a href="/n03_spa/#!/amb-ope/subcredito/documento-nivel/numero/{{solicitacaoHonra.contratoRepasse}}"><i class="fa fa-external-link-alt" ngbTooltip="Acessar Operação"></i></a></span>
                    </div>
                </div>
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.contratoRepasse">
                <label><b>Honra com atualização garantia</b></label>
                <div class="input-group">
                    <input type="checkbox" class="checkbox-gigante" [(ngModel)]="solicitacaoHonra.detalhe.indicadorRemunerarSolicitacaoHonra" disabled/>
                </div>
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-4">
                <label><b>Estado</b></label>
                <input type="text" class="form-control" name="nomeEstado" value="{{solicitacaoHonra.estado.nomeEstado}}" disabled />
            </div>
            <div class="bn-form-group col-md-8">
                <label><b>Motivo</b></label>
                <input type="text" class="form-control" name="motivoEstado" value="{{solicitacaoHonra.estado.motivoEstado}}" disabled />
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-3">
                    <label><b>Parcela inicial solicitada</b></label>
                    <input type="text" class="form-control" name="dataParcelaInicialInadimplente" value="{{solicitacaoHonra.dataParcelaInicialInadimplente | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Parcela inicial a ser honrada</b></label>
                <input type="text" class="form-control" name="dataParcelaInicialASerHonrada" value="{{solicitacaoHonra.dataParcelaInicialASerHonrada | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Data estimativa cálculo honra</b></label>
                <input type="text" class="form-control" name="dataEstimativaHonra" value="{{solicitacaoHonra.dataEstimativaHonra | date:'dd/MM/yyyy'}}"  disabled />
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Valor estimado da honra</b></label>
                <input type="text" class="form-control moeda" name="valorEstimadoHonra" value="{{solicitacaoHonra.valorEstimadoHonra | bnMask:'MOEDA'}}" disabled />
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-3">
                <label><b>Saldo devedor de principal</b></label>
                <input type="text" class="form-control moeda" name="valorSaldoDevedorDePrincipal" value="{{solicitacaoHonra.detalhe.valorSaldoDevedorDePrincipal | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Saldo de juros na normalidade</b></label>
                <input type="text" class="form-control moeda" name="valorSaldoDeJurosNaNormalidade" value="{{solicitacaoHonra.detalhe.valorSaldoDeJurosNaNormalidade | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Saldo Encargos moratórios</b></label>
                <input type="text" class="form-control moeda" name="valorSaldoDeEncargosMoratorios" value="{{solicitacaoHonra.detalhe.valorSaldoDeEncargosMoratorios | bnMask:'MOEDA'}}"  disabled />
            </div>
            <div class="bn-form-group col-md-3" *ngIf="solicitacaoHonra.detalhe.honra">
                <label><b>Data prevista pagto. honra</b></label>
                <input type="text" class="form-control" name="dataPrevistaPagamentoHonra" value="{{solicitacaoHonra.detalhe.honra.dataPrevistaPagamentoHonra | date:'dd/MM/yyyy'}}"  disabled />
            </div>
            <div class="bn-form-group col-md-3" *ngIf="solicitacaoHonra.numeroProcesso" >
                <label><b>Número do processo</b></label>
                <input type="text" class="form-control" name="numeroProcesso" value="{{solicitacaoHonra.numeroProcesso}}"  disabled />
            </div>
            <div class="bn-form-group col-md-3" *ngIf="!solicitacaoHonra.contratoRepasse">
                <label><b>Honra com atualização garantia</b></label>
                <div class="input-group">
                    <input type="checkbox" class="checkbox-gigante" [(ngModel)]="solicitacaoHonra.detalhe.indicadorRemunerarSolicitacaoHonra" disabled/>
                </div>
            </div>
        </div>
        </ng-template></li>

        <li title="Histórico" *ngIf="solicitacaoHonra.detalhe.historicoEstados?.length > 0" [ngbNavItem]>
        <a ngbNavLink>Histórico</a><ng-template ngbNavContent>
          <div class="table-responsive">
          <table class="table table-hover">
              <thead>
              <tr>
                  <th scope="col">Data</th>
                  <th scope="col">Estado</th>
                  <th scope="col">Motivo</th>
                  <th scope="col">Responsável</th>
              <tr>
              </thead>
              <tbody>
              <tr *ngFor="let hist of solicitacaoHonra.detalhe.historicoEstados">
                  <td>{{ hist.dataUltimaAtualizacao | date:'dd/MM/yyyy H:mm'}}</td>
                  <td>{{ hist.estado.nomeEstado }}</td>
                  <td>{{ hist.estado.motivoEstado}}</td>
                  <td>{{ hist.nomeUsuarioResponsavel}}</td>
              </tr>
              </tbody>
          </table>
          </div>
          </ng-template></li>

        <li title="Recebimentos Amortização" *ngIf="solicitacaoHonra.detalhe.recebimentosParciaisDePrincipal?.length > 0" [ngbNavItem]>
        <a ngbNavLink>Recebimentos Amortização</a><ng-template ngbNavContent>
        <div class="table-responsive">
        <table class="table table-hover">
            <thead>
            <tr>
                <th scope="col">Parcela (vencimento)</th>
                <th scope="col" class="moeda">Valor devido</th>
                <th scope="col" class="moeda" *ngIf="!solicitacaoHonra.detalhe.indicadorRemunerarSolicitacaoHonra">Valor recebido</th>
            <tr>
            </thead>
            <tbody>
            <tr *ngFor="let recpar of solicitacaoHonra.detalhe.recebimentosParciaisDePrincipal; let i = index">
                    <td>
                        <input type="text" class="form-control" name="dataPrestacao{{i}}" value="{{recpar.dataPrestacao | date:'dd/MM/yyyy'}}" disabled />
                    </td>
                    <td>
                        <input type="text" class="form-control moeda" name="valorDevido{{i}}" value="{{recpar.valorDevido | bnMask:'MOEDA'}}" disabled />
                    </td>
                    <td *ngIf="!solicitacaoHonra.detalhe.indicadorRemunerarSolicitacaoHonra">
                        <input type="text" class="form-control moeda" name="valorRecebido{{i}}" value="{{recpar.valorRecebido | bnMask:'MOEDA'}}" disabled />
                    </td>
            </tr>
            </tbody>
        </table>
        </div>
        </ng-template>
        </li>

        <li title="Informe de Recebimentos" *ngIf="solicitacaoHonra.detalhe.informeRecebimentosParciaisDePrincipal?.length > 0" [ngbNavItem]>
            <a ngbNavLink>Informe de Recebimentos</a>
            <ng-template ngbNavContent>
            <div class="bn-form-group col-md-3">
                <label><b>Data início inadimplência</b></label>
                <input type="text" class="form-control" name="dataParcelaInicialInadimplente" value="{{solicitacaoHonra.dataParcelaInicialInadimplente | date:'dd/MM/yyyy'}}"  disabled />
            </div>
            <div class="table-responsive col-md-12">
            <table class="table table-hover">
                <thead>
                <tr>
                    <th scope="col">Recebimentos parciais Nº</th>
                    <th scope="col">Data do recebimento</th>
                    <th scope="col" class="moeda">Valor recebido</th>
                <tr>
                </thead>
                <tbody>
                <tr *ngFor="let recpar of solicitacaoHonra.detalhe.informeRecebimentosParciaisDePrincipal; let i = index">
                    <td>
                        <input type="text" class="form-control" value="{{i + 1}}" disabled />
                    </td>
                    <td>
                        <input type="text" class="form-control" name="dataPrestacao{{i}}" value="{{recpar.dataPrestacao | date:'dd/MM/yyyy'}}" disabled />
                    </td>
                    <td>
                        <input type="text" class="form-control moeda" name="valorRecebido{{i}}" value="{{recpar.valorRecebido | bnMask:'MOEDA'}}" disabled />
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
            </ng-template>
        </li>

        <li title="Processamento"  *ngIf="permissaoLinkN03 && solicitacaoHonra.detalhe.honra" [ngbNavItem]>
        <a ngbNavLink>Processamento</a><ng-template ngbNavContent>
        <div class="row">
            <div class="bn-form-group col-md-4">
                <label><b>Número do contrato</b></label>
                <input type="text" class="form-control" name="numeroContrato" value="{{solicitacaoHonra.detalhe.honra.numeroContrato}}" disabled />
            </div>
            <div class="bn-form-group col-md-4">
                <label><b>Estado</b></label>
                <input type="text" class="form-control" name="estadoHonra" value="{{solicitacaoHonra.detalhe.honra.estado.nomeEstado}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'L'">
                <label><b>Fatura</b></label>
                <input type="text" class="form-control" name="fatura" value="{{solicitacaoHonra.detalhe.honra.fatura?.numeroDocumento ? solicitacaoHonra.detalhe.honra.fatura?.siglaEmpresa + ' / ' + solicitacaoHonra.detalhe.honra.fatura?.numeroDocumento + ' / ' + solicitacaoHonra.detalhe.honra.fatura?.anoExercicio : ''}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Fatura parcelas vencidas</b></label>
                <input type="text" class="form-control" name="faturaParcelasVencidas" value="{{solicitacaoHonra.detalhe.honra.faturaParcelasVencidas?.numeroDocumento ? solicitacaoHonra.detalhe.honra.faturaParcelasVencidas?.siglaEmpresa + ' / ' + solicitacaoHonra.detalhe.honra.faturaParcelasVencidas?.numeroDocumento + ' / ' + solicitacaoHonra.detalhe.honra.faturaParcelasVencidas?.anoExercicio : ''}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Fatura parcelas vincendas</b></label>
                <input type="text" class="form-control" name="faturaParcelasVincendas" value="{{solicitacaoHonra.detalhe.honra.faturaParcelasVincendas?.numeroDocumento ? solicitacaoHonra.detalhe.honra.faturaParcelasVincendas?.siglaEmpresa + ' / ' + solicitacaoHonra.detalhe.honra.faturaParcelasVincendas?.numeroDocumento + ' / ' + solicitacaoHonra.detalhe.honra.faturaParcelasVincendas?.anoExercicio : ''}}" disabled />
            </div>
            <div class="bn-form-group col-md-4">
                <label><b>Data de vencimento</b></label>
                <input type="text" class="form-control" name="dataPrevistaPagamentoHonra" value="{{solicitacaoHonra.detalhe.honra.dataPrevistaPagamentoHonra | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'L'">
                <label><b>Data de pagamento</b></label>
                <input type="text" class="form-control" name="dataEfetivaPagamentoHonra" value="{{solicitacaoHonra.detalhe.honra.dataEfetivaPagamentoHonra | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Data de pagamento parcelas vencidas</b></label>
                <input type="text" class="form-control" name="dataEfetivaPagamentoHonraParcelasVencidas" value="{{solicitacaoHonra.detalhe.honra.dataEfetivaPagamentoHonraParcelasVencidas | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Data de pagamento parcelas vincendas</b></label>
                <input type="text" class="form-control" name="dataEfetivaPagamentoHonraParcelasVincendas" value="{{solicitacaoHonra.detalhe.honra.dataEfetivaPagamentoHonraParcelasVincendas | date:'dd/MM/yyyy'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'L'">
                <label><b>Valor devido</b></label>
                <input type="text" class="form-control moeda" name="valorHonraDevidoEmReais" value="{{solicitacaoHonra.detalhe.honra.valorHonraDevidoEmReais | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Valor devido parcelas vencidas</b></label>
                <input type="text" class="form-control moeda" name="valorHonraParcelasVencidasEmReais" value="{{solicitacaoHonra.detalhe.honra.valorHonraParcelasVencidasEmReais | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Valor devido parcelas vincendas</b></label>
                <input type="text" class="form-control moeda" name="valorHonraParcelasVincendasEmReais" value="{{solicitacaoHonra.detalhe.honra.valorHonraParcelasVincendasEmReais | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'L'">
                <label><b>Valor pago</b></label>
                <input type="text" class="form-control moeda" name="valorEfetivoPagamentoHonraEmReais" value="{{solicitacaoHonra.detalhe.honra.valorEfetivoPagamentoHonraEmReais | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Valor pago parcelas vencidas</b></label>
                <input type="text" class="form-control moeda" name="valorEfetivoPagamentoHonraEmReaisParcelasVencidas" value="{{solicitacaoHonra.detalhe.honra.valorEfetivoPagamentoHonraEmReaisParcelasVencidas | bnMask:'MOEDA'}}" disabled />
            </div>
            <div class="bn-form-group col-md-4" *ngIf="solicitacaoHonra.detalhe.honra.codigoTipoOperacao == 'R'">
                <label><b>Valor pago parcelas vincendas</b></label>
                <input type="text" class="form-control moeda" name="valorEfetivoPagamentoHonraEmReaisParcelasVincendas" value="{{solicitacaoHonra.detalhe.honra.valorEfetivoPagamentoHonraEmReaisParcelasVincendas | bnMask:'MOEDA'}}" disabled />
            </div>
        </div>
        </ng-template></li>

        <li title="Validações" *ngIf="podeVisualizarValidacoes && solicitacaoHonra?.detalhe.arquivosScrUtilizadosNaValidacao?.length > 0" [ngbNavItem]>
        <a ngbNavLink>Validações</a><ng-template ngbNavContent>
            <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                <tr>
                    <th scope="col">Id Arquivo SCR</th>
                    <th scope="col">Data Base</th>
                    <th scope="col">Data validação</th>
                    <th scope="col">Tipo validação</th>
                    <th scope="col">Troca IPOC</th>
                <tr>
                </thead>
                <tbody>
                <tr *ngFor="let arquivo of solicitacaoHonra?.detalhe.arquivosScrUtilizadosNaValidacao">
                    <ng-container *ngIf="arquivo?.arquivoScrUtilizadoNaValidacao as arquivoScr; else semArquivo">
                        <td> <a (click)="visualizarOperacao(arquivo)" href="javascript:void(0)">{{ arquivoScr.id }}</a></td>
                        <td>{{ arquivoScr.referencia+'01' | date: 'MM/yyyy' }}</td>
                    </ng-container>
                    <ng-template #semArquivo>
                        <td>-</td>
                        <td>-</td>
                    </ng-template>
                    <td>{{ arquivo.dataValidacao | date:'dd/MM/yyyy'}}</td>
                    <td>{{ labelTipoValidacaoScr(arquivo.tipoValidacao) }}</td>
                    <td>{{ arquivo.trocaIpoc ? 'Sim' : 'Não'}}</td>
                </tr>
                </tbody>
            </table>
            </div>
            </ng-template></li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>

<ng-template #reprovacao>
    <label for="motivoReprovacao"><b>Motivo para reprovação</b></label>
    <input type="text" class="form-control" id="motivoReprovacao" name="motivoReprovacao" [(ngModel)]="motivoReprovacao" required />
</ng-template>
<ng-template #reprovacaoBotoes >
    <button class="btn btn-default" (click)="cancelaReprovacao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmaReprovacao()">Confirmar</button>
</ng-template>

<div class="container row" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
